export const ulCss = {
  ul: {
    width: "100%",
    zIndex: "1",
  },
  "ul > li > div": {
    display: "flex",
    justifyContent: "space-between",
  },
  "ul > li": {
    paddingRight: "24px",
  },
};
